export const acclarisData = {
    projectHeading: 'The Acclaris Project (Mock Data In Images)',
    projectMainImage: {
        image: '/images/portfolio/acclaris/acclaris-main.jpg',
        alt: 'Acclaris Banner'
    },
    additionalImages: [
        {
            fullImage: '/images/portfolio/acclaris/acclaris-main.jpg',
            image: '/images/portfolio/acclaris/acclaris-main-thumb.jpg',
            alt: 'Acclaris Main Page (Test Account)'
        },
        {
            fullImage: '/images/portfolio/acclaris/acclaris-main-theme.jpg',
            image: '/images/portfolio/acclaris/acclaris-main-theme-thumb.jpg',
            alt: 'Different Theme Main Page (Test Account)'
        },
        {
            fullImage: '/images/portfolio/acclaris/claims.jpg',
            image: '/images/portfolio/acclaris/claims-thumb.jpg',
            alt: 'Claims Page (Test Account)'
        },
        {
            fullImage: '/images/portfolio/acclaris/login.png',
            image: '/images/portfolio/acclaris/login-thumb.png',
            alt: 'Login Page (Test Account)'
        },
        {
            fullImage: '/images/portfolio/acclaris/payments.jpg',
            image: '/images/portfolio/acclaris/payments-thumb.jpg',
            alt: 'Payments Page (Test Account)'
        },
        {
            fullImage: '/images/portfolio/acclaris/profile.jpg',
            image: '/images/portfolio/acclaris/profile-thumb.jpg',
            alt: 'Profile Page (Test Account)'
        },
        {
            fullImage: '/images/portfolio/acclaris/test-accounts.jpg',
            image: '/images/portfolio/acclaris/test-accounts-thumb.jpg',
            alt: 'Accounts Page (Test Account)'
        }
    ],
    aboutHeading: 'About the Acclaris 1.5 Project',
    aboutPortfolioText: [
        `Acclaris is a health insurance company that manages the digital assets of various companies and their employees. They have
         a split workforce between America and India, with a majority of the development team being located in India.`
    ],
    websiteGoalsHeading: 'Website Goals',
    websiteGoalsText: [
        `The purpose of the Acclaris 1.5 project was to take their current website, and implement a number of changes to dramatically
         improve the look and feel of the site—all without changing the HTML structure. There was a tight deadline for the turnaround on the
         project—it had to be done in 3 months, with no design or strategy in place.`
    ],
    websiteGoalsListHeading: 'Website Goals List',
    websiteGoalsList: [
        `Update the website's design without changing the HTML`,
        `Design the site to be customizable for various clients (different color schemes)`,
        `Maintain backwards compatibility for the version 1.0 site`,
        `Allow both 1.0 and 1.5 to take in simultaneous updates to minimize code management`,
        `Complete the core update within 3 months`
    ],
    myRoleHeading: 'My Role On The Acclaris 1.5 Project',
    position: 'Frontend Developer',
    company: 'Acclaris',
    timeWithCompany: '1 year 11 months',
    myRoleText: [
        `I was brought into the company temporarily as a contractor, with the goal of giving their main system a design 'facelift' to
         help appease their customers until the Acclaris 2.0 project could be completed later that year. Fortunately, they were
         so impressed with the work I provided, my contract was bought out early and I continued as the lead front end developer on into the Acclaris 2.0 project`,

        `I designed all of the mockups for the Acclaris 1.5 project, and then worked with the team on a strategy to implement the changes
         in a quick but efficient manner. The project was so successful with all of the company's clients, they were able to move
         the deadline for the 2.0 project back an entire year.
        `
    ],
    jobSummaryIntro: 'Following is a summary of my responsibilities while working on the Acclaris 1.5 project',
    jobSummaryList: [
        `Design and implement a sass architecture system for style overlays in the portal`,
        `Redesign system to improve CSS deployments through the CI/CD pipeline (went from 10 days to being deployed same day) `,
        `Design all of the pages for the Acclaris 1.5 Portal`,
        `Layout and build Acclaris 2.0 Portal project in Angular 2.0+`,
        `Work with developers in India for meeting project deadlines`,
        `Train new developers`,
        `Manage developers' workload and tasks in Arizona`,
        `Work close with the architect for the layout/implementation within the 2.0 Portal`,
        `Meet weekly with the team designer and discuss upcoming changes in the design of the 2.0 Portal`
    ],
    technologiesUsedIntro: `This section contains the technologies used for building the Acclaris website.`,
    technologiesList: [
        `Angular 2+`,
        `HTML5`,
        `CSS3`,
        `Sass`,
        `Photoshop`,
        `Illustrator`,
        `Java`,
        `JBoss`,
        `Bourbon`,
        `Bourbon Neat`,
        `TypeScript`,
        `jQuery`,
        `Karma`,
        `Jasmine`,
        `Jira`,
        `Git`,
        `Gulp`,
        `NodeJS`,
        `PHP`,
        `Xampp`,
        `PL/SQL`,
        `IcoMoon`
    ]
}